import { StyledTags } from "./tags.scss";

const Tags = ({ tags, translate }) => (
  <StyledTags color={tags?.color}>
    <span className="tags-title-wrapper">{translate("header.tabs.products.tags.bestFor")}</span>

    <div className="tags-wrapper">
      {tags?.labels?.map((tag) => (
        <div key={tag} className="tag">
          {translate(tag)}
        </div>
      ))}
    </div>
  </StyledTags>
);

export default Tags;
